<div id="address_map" [style.height]="height">
	<div *ngIf="bGeocoding" class="div-backdrop">
		<ion-spinner></ion-spinner>
	</div>
</div>
